const Footer = () => {
    return (
        <div className = "w-full h-8 bg-gray-500 shadow-lg mt-12" >
            <div className="text-center">
                <ul className="flex justify-evenly ">
                    <li className=" text-white text-xs mt-1">Terms & Conditions</li>
                    <li className=" text-white text-xs mt-1">Cookie Policy</li>
                    <li className=" text-white text-xs mt-1">Privacy Policy</li>
                    <li className=" text-white text-xs mt-1">Investor Relations</li>
                </ul>
            </div>
        </div>
    );
};
export default Footer;